import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthenticatedUserInfos, selectIsAuthenticatedUser, selectTaxesDisplaySetting } from '@gandi/authentication';
import { selectCurrent } from '@gandi/redux-sharing';
import { localeSelector as selectLocale } from '@gandi/translate';
import { setProps } from '@gandi/tracking';
import { selectPricingInfos } from '../modules/pricing';
export var useTrackingProps = function useTrackingProps() {
  var userInfo = useSelector(selectAuthenticatedUserInfos);
  var currentOrg = useSelector(selectCurrent);
  var _ref = currentOrg || {
      id: userInfo === null || userInfo === void 0 ? void 0 : userInfo.user_id
    },
    orgaCountry = _ref.country,
    sharingId = _ref.id,
    bu = _ref.bu_id;
  var billingProps = React.useMemo(function () {
    return {
      sharingId: sharingId
    };
  }, [sharingId]);
  var _useSelector = useSelector(selectPricingInfos),
    grid = _useSelector.grid,
    userCountry = _useSelector.country,
    currency = _useSelector.currency;
  var loggedin = useSelector(selectIsAuthenticatedUser);
  var lang = useSelector(selectLocale);
  var taxesIncluded = useSelector(selectTaxesDisplaySetting);
  var taxes = taxesIncluded ? 'true' : 'false';
  var country = orgaCountry || userCountry;
  var dispatch = useDispatch();
  React.useEffect(function () {
    // Get up-to-date pricing infos
    setProps({
      country: country,
      currency: currency,
      grid: grid,
      lang: lang,
      loggedin: loggedin,
      taxes: taxes
    }, {
      persistent: true,
      events: ['page.*']
    });
  }, [billingProps, country, currency, dispatch, grid, lang, loggedin, taxes]);
  React.useEffect(function () {
    setProps({
      bu: bu
    }, {
      persistent: true,
      events: ['*']
    });
  }, [bu]);
};